import { Container, Row } from "react-bootstrap";
import Particle from "../Particle";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";


function Scholarship() {
  
 
  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />


        <Row>
        <h1 class="vw-page-title">Scholarship</h1>
   
  
   <p>The Justin &amp; Michelle Allard Scholarship was started in 2024.</p>
   
   
   
   <p></p>
   
   
   
   <p><strong>Scholarship Recipients:</strong></p>
   
   
   
   <p>2024 – Camryn Clark</p>
        </Row>

       

      
      </Container>
    </div>
  );
}

export default Scholarship;
